module.exports = __webpack_public_path__ + "assets/elsa-logo-3.c8bb15d3.svg";